export default __webpack_public_path__ + "static/media/Pillar_Middle.256.ae59716d.png";